<template>
    <div class="panel-content">
        <h2>Nuclear Health Centre (NHC)</h2>
        <img class="header" src="/static/img/overlay-assets/header2-3.jpg" />
        <p>Het Nuclear Health Centre (NHC), dat naar verwachting in 2022 zijn deuren opent, gaat op grote schaal bestraalde grondstoffen (medische isotopen) tot halfproduct (radiochemicaliën) en medicijnen (radiofarmaca) verwerken en verpakken. Met deze producten kunnen miljoenen patiënten in ziekenhuizen worden behandeld. In de medische wereld is een grote behoefte aan productiefaciliteiten die in opdracht van ziekenhuizen of farmaceutische bedrijven bestraalde materialen kunnen verwerken tot medicijnen. Het NHC wordt gebouwd op de Energy & Health Campus (EHC), in de nabijheid van de huidige reactor (de Hoge Flux Reactor) en de toekomstige PALLAS-reactor. De productiefaciliteit is complementair aan het FIELD-LAB en andere faciliteiten op de EHC. Dit alles heeft als voordeel een geïntegreerde supply chain te bieden en daarmee efficiënt om te gaan met materialen, vervalverlies van bestraalde producten, radioactief transport, afval en de nucleaire kennis en ervaring van de verschillende nucleaire bedrijven op de EHC.</p>
        <a @click="trackLink" class="button" href="https://pallasreactor.com/nhc" target="_blank">Meer informatie</a>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    export default {
        methods: {
            trackLink()
            {
                window.dataLayer.push({ 'event': 'clickout', 'url': 'https://pallasreactor.com/nhc' });
            }
        }
    };
</script>
